"use client";

import useFetchApi from "@/hooks/useFetchApi";
import { Dropdown, Menu } from "antd";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";

const MenuComponent = ({ menuItems, drawer = false }) => {
  const pathname = usePathname();
  const [current, setCurrent] = useState("home");
  const onClick = (e) => {
    setCurrent(e.key);
  };
  const showChildren = (e, isShown) => {
    if (!isShown) {
      setKey("");
      return;
    }
    if (e.children?.length) {
      setKey(e.id);
    }
  };
  return (
    <>
      <div
        className={`flex ${drawer ? "flex-col gap-4 p-2" : "flex-row flex-wrap items-center gap-4 md:gap-6 lg:gap-8 xl:gap-12"}`}
      >
        {menuItems.map((item, index) => {
          return (
            <Link
              key={item.slug}
              className={`font-semibold text-sm md:text-base lg:text-lg whitespace-nowrap ${
                pathname === item.slug
                  ? "text-[#007AFF]"
                  : `${drawer ? "text-gray-500" : "text-white"}`
              }`}
              href={item.slug}
            >
              {item.label}
            </Link>
          );
        })}
      </div>
    </>
  );
};

export default MenuComponent;
